<template>
  <el-dialog :visible.sync="visible" title="班级评价记录统计" :close-on-click-modal="false" :close-on-press-escape="false"
    customClass="customWidth">
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-club__classhour">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="query()">
          <!-- <el-form-item prop="rollDate">
            <el-date-picker v-model="dataForm.selectDate" type="date" placeholder="点名日期">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-date-picker v-model="rollCallDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="教师姓名" v-model="dataForm.teacherName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click.native="query()" type="primary">{{ $t('query') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportList()">{{ $t('export') }}</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="table" v-loading="dataListLoading" height="740px" :data="dataList" border
          @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
          <el-table-column prop="teacherName" label="教师姓名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="teacherEvaluateSize" label="评价总条数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="addScoreCount" label="加分项条数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="addScore" label="加分项总分" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cutScoreCount" label="扣分项条数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cutScore" label="扣分项总分" header-align="center" align="center"></el-table-column>
          <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="inspectorEvaluateStatisticsDetails(scope)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 弹窗, 查看教师评分详情 -->
        <inspector-evaluate-statistics-details v-if="inspectorEvaluateStatisticsDetailsVisible"
          ref="inspectorEvaluateStatisticsDetails" @refreshDataList="getDataList"></inspector-evaluate-statistics-details>
      </div>
    </el-card>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import InspectorEvaluateStatisticsDetails from './inspector-evaluate-statistics-details'
import qs from 'qs'
import Cookies from 'js-cookie'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListIsPage: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      dataForm: {
        teacherName: '',
        selectDate: '',
        startTime:'',
        endTime:''
      },
      inspectorEvaluateStatisticsDetailsVisible: false,
      visible: false,
      rollCallDate: []
    }
  },
  watch: {},
  components: {
    InspectorEvaluateStatisticsDetails
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    init() {
      this.visible = true
      this.getDataList()
      this.$nextTick(() => {
      })
    },
    query() {
      if (this.dataForm.selectDate === '') {
        this.dataForm.selectDate = new Date()
      }
      const date = new Date(this.dataForm.selectDate)
      const selectDate = date.getFullYear() + '-' + (this.appendZero(date.getMonth() + 1)) + '-' + this.appendZero(date.getDate())
      const url = '/classEvaluate/evaluateScore/inspectorEvaluateStatistics'
      this.dataListLoading = false
      if (this.rollCallDate.length <= 1) {
          this.dataForm.startTime = ''
          this.dataForm.endTime = ''
        } else {
          const date = new Date(this.rollCallDate[0])
          this.dataForm.startTime =
              date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              '00:00:00'
          const date2 = new Date(this.rollCallDate[1])
          this.dataForm.endTime =
              date2.getFullYear() +
              '-' +
              (date2.getMonth() + 1) +
              '-' +
              date2.getDate() +
              ' ' +
              '23:59:59'
        }
      this.$http.get(
        url,
        {
          params: {
            teacherName: this.dataForm.teacherName,
            selectDate: selectDate,
            startTime: this.dataForm.startTime,
            endTime:this.dataForm.endTime
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        console.log(res)
        if (res.code !== 0) {
          this.dataList = []
        }
        this.dataList = res.data
        this.$refs.table.doLayout()
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    getPage () {
      if (this.rollCallDate !== null) {
        const date = new Date(this.rollCallDate[0])
        this.dataForm.startTime =
          date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate() +
          ' ' +
          '00:00:00'
        const date2 = new Date(this.rollCallDate[1])
        this.dataForm.endTime =
          date2.getFullYear() +
          '-' +
          (date2.getMonth() + 1) +
          '-' +
          date2.getDate() +
          ' ' +
          '23:59:59'
      } else {
        console.log(222222)
        this.rollCallDate = []
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
      }
      this.init()
    },
    appendZero(obj) {
      if (obj < 10) {
        return '0' + obj
      } else {
        return obj
      }
    },
    inspectorEvaluateStatisticsDetails(scope) {
      console.log('上个页面数值',this.dataForm)
      this.inspectorEvaluateStatisticsDetailsVisible = true
      this.$nextTick(() => {
        this.$refs.inspectorEvaluateStatisticsDetails.dataForm.creator = scope.row.teacherUserId
        const date = new Date(this.dataForm.selectDate)
        const selectDate = date.getFullYear() + '-' + (this.appendZero(date.getMonth() + 1)) + '-' + this.appendZero(date.getDate())
        this.$refs.inspectorEvaluateStatisticsDetails.dataForm.selectDate = selectDate
        this.$refs.inspectorEvaluateStatisticsDetails.dataForm.startTime = this.dataForm.startTime
        this.$refs.inspectorEvaluateStatisticsDetails.dataForm.endTime = this.dataForm.endTime
        this.$refs.inspectorEvaluateStatisticsDetails.init()
      })
    },
    exportList() {
      if (this.dataForm.selectDate === '') {
        this.dataForm.selectDate = new Date()
      }
      const date = new Date(this.dataForm.selectDate)
      const selectDate = date.getFullYear() + '-' + (this.appendZero(date.getMonth() + 1)) + '-' + this.appendZero(date.getDate())
      const params = qs.stringify({
        token: Cookies.get('token'),
        teacherName: this.dataForm.teacherName,
        selectDate: selectDate,
        startTime: this.dataForm.startTime,
        endTime: this.dataForm.endTime
      })
      window.location.href = `${window.SITE_CONFIG.apiURL}/classEvaluate/evaluateScore/exportInspectorEvaluateStatistics?${params}`
    }
  }
}
</script>
<style>
.customWidth {
  width: 70%;
}
</style>
